import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FranchiseInDTO } from '../../franchises/type';
import { EMarketingDTO } from '../type';

export interface EMarketingState {
  entity?: EMarketingDTO;
  ids: string[];
  isLoading: boolean;
  hasError: boolean;
  franchise?: Partial<FranchiseInDTO>;
  eMarketingDialog: {
    type: 'new' | 'edit';
    isOpen: boolean;
    isLoading: boolean;
    data?: EMarketingDTO;
  };
}

const initialState: EMarketingState = {
  entity: undefined,
  ids: [],
  isLoading: false,
  hasError: false,
  franchise: undefined,
  eMarketingDialog: {
    type: 'new',
    isOpen: false,
    isLoading: false,
    data: undefined,
  },
};

export const { actions, reducer } = createSlice({
  name: 'E-Marketing',
  initialState,
  reducers: {
    setLoading: (state: EMarketingState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state: EMarketingState, action: PayloadAction<boolean>) => {
      state.hasError = action.payload;
    },
    setEntity: (state: EMarketingState, action: PayloadAction<EMarketingDTO>) => {
      state.hasError = false;
      state.entity = action.payload;
    },
    setFranchise: (state: EMarketingState, action: PayloadAction<FranchiseInDTO>) => {
      state.franchise = action.payload;
    },
    openNewEMarketingDialog: (state: EMarketingState) => {
      state.eMarketingDialog = {
        ...state.eMarketingDialog,
        type: 'new',
        isOpen: true,
        isLoading: false,
        data: undefined,
      };
    },
    openEditEMarketingDialog: (state: EMarketingState) => {
      state.eMarketingDialog = {
        ...state.eMarketingDialog,
        type: 'edit',
        isOpen: true,
        isLoading: false,
        data: state.entity,
      };
    },
    closeEMarketingDialog: (state: EMarketingState) => {
      state.eMarketingDialog = {
        ...state.eMarketingDialog,
        type: 'new',
        isOpen: false,
        data: undefined,
      };
    },
    setEMarketingDialogIsLoading: (state: EMarketingState, action: PayloadAction<boolean>) => {
      state.eMarketingDialog = {
        ...state.eMarketingDialog,
        isLoading: action.payload,
      };
    },
  },
});
